/**
 * Typographie française : espace insécable avant « : ; ? ! » et à l'intérieur
 * des guillemets « », pour qu'un signe ne se retrouve jamais seul en début
 * de ligne (Karim 2026-10-18 : « ? » orphelin dans la FAQ sur téléphone).
 * Sans effet sur les autres langues (pas d'espace avant ces signes).
 */
export function insecables(texte: string): string {
  return texte.replace(/ ([:;?!»])/g, " $1").replace(/« /g, "« ");
}
